import BASE from './es.json';
import Sched from '../automationObjects/Functions/Scheduler/lang/es.json'
import Cal from '../automationObjects/Functions/Calendar/lang/en.json'
import Device from '../automationObjects/Devices/lang/es.json'
import FG_SauterCooling from '../automationObjects/FunctionGroups/FG_SAUTER_CoolingSetpoint/lang/es.json'
import FG_SauterHeating from '../automationObjects/FunctionGroups/FG_SAUTER_HeatingSetpoint/lang/es.json'
import PID from '../automationObjects/Functions/PID/lang/es.json'
import controlledPID from '../automationObjects/Functions/ControlledPID/lang/es.json'
import controlled2Point from '../automationObjects/Functions/Controlled2Point/lang/es.json'
import SubPlants from '../automationObjects/SubPlants/lang/es.json'
import Plants from'../automationObjects/Plants/lang/es.json'
import P_AirHandlingUnit from'../automationObjects/Plants/AirHandlingUnits/P_AirHandlingUnit/lang/es.json'
import P_Building from'../automationObjects/Plants/Buildings/P_Building/lang/es.json'
import BuildingCompare from '../automationObjects/ReportsAndStatistics/Portfolio/BuildingsCompare/lang/es.json'
import P_Floor from'../automationObjects/Plants/Buildings/P_Floor/lang/es.json'
import {es as Utils } from'../automationObjects/Utils/lang/es'
import RelationsView from '../features/RelationsView/lang/es.json'
import SP_Room from '../automationObjects/SubPlants/SP_Room/lang/es.json'
import User from '../components/User/lang/es.json'
import ValueDisplay from '../automationObjects/components/ValueDisplay/lang/es.json'
import Dashboard from '../features/Dashboard/lang/es.json'
import MoveApp from '../features/MoveApp/lang/es.json'
import PortfolioReports from '../automationObjects/ReportsAndStatistics/lang/es.json'
import LogicReference from '../automationObjects/components/LogicReference/lang/es.json'
import Logics from '../automationObjects/Logics/lang/es.json'
import EnergyBarChart from '../components/EnergyBarCharts/lang/es.json'
import controlledShiftFunction4Point from '../automationObjects/Functions/ControlledShiftFunction4Point/lang/es.json'
import Energy from '../automationObjects/Energy/EnergyRates/lang/es.json'
import UserInteractions from '../features/UserInteractions/lang/es.json'
import Functions from '../automationObjects/Functions/lang/es.json'
import CloneAppDialog from '../features/CloneAppDialog/lang/es.json'
import KPI from '../automationObjects/KPIs/lang/es.json'

export const ES = {
  ...BASE,
  ...EnergyBarChart,
  ...Energy,
  ...Sched,
  ...Cal,
  ...Device,
  ...FG_SauterCooling,
  ...FG_SauterHeating,
  ...PID,
  ...SubPlants,
  ...Plants,
  ...P_AirHandlingUnit,
  ...P_Building,
  ...P_Floor,
  ...Utils,
  ...RelationsView,
  ...SP_Room,
  ...User,
  ...ValueDisplay,
  ...Dashboard,
  ...MoveApp,
  ...BuildingCompare,
  ...PortfolioReports,
  ...LogicReference,
  ...controlledPID,
  ...controlled2Point,
  ...Logics,
  ...controlledShiftFunction4Point,
  ...UserInteractions,
  ...Functions,
  ...CloneAppDialog,
  ...KPI
};